import React from 'react'
import { compose, graphql } from 'react-apollo'
import Gallery from 'react-grid-gallery'
import { message } from 'antd'
import photosFromFaceQuery from '~/graphql/queries/photosFromFace.gql'
import searchingImg from '~/images/searching.gif'
import { Notice, Results } from '~/styles'

const sortFn = (a, b) => b.similarity - a.similarity
const mapFn = photo => ({
  src: photo.view.preview.url,
  thumbnail: photo.view.thumbnail.url,
  thumbnailWidth: photo.view.thumbnail.size.width,
  thumbnailHeight: photo.view.thumbnail.size.height
})

const PhotoList = ({ searcPhotoByFace }) => {
  if (!searcPhotoByFace) {
    return <div>Loading...</div>
  }
  const { photosFromFace = [], loading, error } = searcPhotoByFace
  if (error) {
    error.graphQLErrors.forEach(err => message.error(err.message))
  }
  const photos = photosFromFace.filter(photo => photo.similarity >= 85).sort(sortFn).map(mapFn)

  const likelyPhotos = photosFromFace.filter(photo => photo.similarity < 85).sort(sortFn).map(mapFn)
  return <Results>
      {loading ? (
        <div className="loading">
          <img src={searchingImg} alt="searching..." />
        </div>
      ) : (<div className="photos">
          {photos.length > 0 ? [
            <div className="sectionHeader" key="separator">พบภาพใบหน้าคุณจำนวน {photos.length} ภาพ.</div>,
            <div className="galleryContainer" key="photos">
              <Gallery images={photos} enableImageSelection={false} />
            </div>
          ]
          :
          <Notice>ไม่พบภาพคุณในระบบ</Notice>
          }
          {likelyPhotos.length > 0 ? [
            <div className="sectionHeader" key="separator">ภาพเหล่านี้คล้ายคุณนะ... อาจจะใช่คุณ</div>,
            <div className="galleryContainer" key="likelyPhotos">
              <Gallery images={likelyPhotos} enableImageSelection={false} />
            </div>
          ]
          :
          <Notice>ไม่พบใบหน้าที่คล้ายคุญ</Notice>
          }
        </div>
      )}
    </Results>
}

export default compose(
  graphql(photosFromFaceQuery, {
    options: ({ eventId, refData }) => ({
      skip: !refData,
      variables: {
        eventId,
        refData: {
          mimeType: refData && refData.mimeType,
          base64data: refData && refData.base64data
        }
      },
      fetchPolicy: 'network-only'
    }),
    name: 'searcPhotoByFace'
  })
)(PhotoList)


// WEBPACK FOOTER //
// ./src/PhotoList.jsx